import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../blocks/ConfirmationModal";

interface Props {
  title?: string;
  msg: ReactNode;
  onClick: () => void;
  disableConfirmButton?: boolean;
}

const ModalAlert = ({ title, msg, onClick, disableConfirmButton = false }: Props) => {
  const { t } = useTranslation(["common"]);
  return (
    <ConfirmationModal
      onConfirm={onClick}
      onCancel={onClick}
      confirmButtonText={t(($) => $.common.actions.Continue)}
      modalButtonText={null}
      title={title ?? t(($) => $.common.modalAlert.Error)}
      defaultShowState={true}
      confirmationMessage={msg}
      hideCancelButton={true}
      confirmButtonStyles={{ transform: "none", marginTop: "1rem" }}
      disableConfirmButton={disableConfirmButton}
    />
  );
};

export default ModalAlert;
